import React from "react";
import { Box, Flex, Text, Image, SimpleGrid } from "@chakra-ui/react";

export const TestimonialCard = ({ testimonial, name, image, grade }) => {
  return (
    <Box border="2px solid #D9D9D9" borderRadius="24px" p="55px 37px 66px 37px" width="fit-content">
      <Text
        width="18px"
        height="37px"
        color="#232424"
        fontSize="48px"
        fontWeight="400"
        mb="20px"
      >
        “
      </Text>
      <Text
        width="293px"
        height="103px"
        color="#232424"
        fontSize="14px"
        fontWeight="400"
        mb="114px"
      >
        {testimonial}
      </Text>
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Image
          src={image}
          alt={name}
          boxSize = "85px"
          borderRadius="8px"
          background="#D9D9D9"
          objectFit="cover"
        />
        <Text
          alignSelf="stretch"
          color="#232424"
          fontSize="14px"
          fontWeight="500"
          whiteSpace="nowrap" 
        >
          {name}
        </Text>
        <Flex
          width="44px"
          height="45px"
          padding="18px"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="5.088px"
          borderRadius="45.21px"
          background="#EBF2F7"
        >
          <Text
            color="#062A44"
            textAlign="center"
            fontSize="12px"
            fontWeight="600"
            whiteSpace="nowrap" 

          >
            {grade}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

